import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemButton,
    FormControlLabel,
    Checkbox,
    List,
    ListItem,
    Chip,
} from '@mui/material';

import dayjs from "dayjs";

import {
    LoadingButton
} from '@mui/lab';

import { grey } from "@mui/material/colors";

import {
    Draggable,
    DragDropContext,
    Droppable,
    OnDragEndResponder
} from 'react-beautiful-dnd';

import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
// import LocationSelector from "../../selector/LocationSelector";

// import SearchCustomers from "../../dialog/SearchCustomers";
// import SearchItems from "../../dialog/SearchItems";
import SearchPickDocuments from "../../dialog/SearchPickDocuments";
import { reOrderArray } from "../../../utils/formatArray";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';

import { CommonIcons, icons } from "../../common/CommonIcons";
import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";

import { useTranslations } from "../../../hooks/useTranslations";

import { validationSchema, validationUpdateSchema, initialValues, initialRowValues } from "../../../schema/documents/pickOrderSchema";

import { checkValueExists, mergeSchema } from "../../../utils/dataSchema";

import { capitalizeString } from "../../../utils/formatString";

const StyledCard = styled(Card)(({ theme }) => ({
    padding : theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width : 20,
    height : 20,
    textAlign : 'center',
    alignItems : 'center',
    justifyContent : 'center',
});


const styles = {
    draggingListItem : {
        background : 'rgb(235,235,235)'
    },
    flexPaper : {
        flex : 1,
        margin : 16,
        minWidth : 350
    },
}

export default function UpdatePickOrder({
    routeType
}){
    const { t } = useTranslations({ ns : ["common", "prompt", "@document"] })

    const { id } = useParams();

    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    const { authData, getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.pickOrder.id)

    const { setSystemLoading } = useAppContextFeatures();
    const { isLoading, get, update, filterOperatorTypes } = useDocuments({
        documentType : documentTypes.pickOrder,
        targetType : targetTypes.pickOrder
    })

    // const [ selectLocationIds, setSelectLocationIds ] = useState()
    const [savedValues, setSavedValues] = useState()

    const availableLocations = getAvailableLocations();


    const [actionConfirm, setActionConfirm] = useState(false)

    const validationSchemaCombine = mergeSchema(validationSchema, validationUpdateSchema);

    const loadData = async (id) => {

        setSystemLoading(true)

        try {

            const { data } = await get({ id })
            const { document, docs } = data;

            // create rows
            const rows = docs.map((i) => {
                return {
                    id : i?.doc_id,
                    documentDocId : i?.id,
                    name : i?.doc_number,
                    description : i?.doc_remark
                }
            })

            setSavedValues({
                ...initialValues,

                locationId : document?.location_id,
                locationName : document?.location_name,
                documentNumber : document?.doc_number,
                documentDate : dayjs(document?.doc_date),
                remark : document?.doc_remark ? document.doc_remark : "",
                referenceNo : document?.reference_no ? document.reference_no : "",

                isConfirmStatus : document?.is_confirm_status,
                isConfirmDate : document?.is_confirm_date,

                rows
            })
        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }


    const onSubmit = async (currentValues) => {

        try {

            const document = {
                doc_date : currentValues.documentDate.format("YYYY-MM-DD"),
                doc_remark : currentValues.remark,
            }

            const status = {
                confirm : actionConfirm ? "1" : "0"
            }

            const profiles = {}

            const props = {
                location_id : currentValues.locationId,
                reference_no : currentValues.referenceNo
            }

            let items = [];

            currentValues.rows.map((item, index) => {
                items.push({
                    document_id : item?.id,
                    document_doc_id : item?.documentDocId,
                    doc_remark : item?.description,
                    props : {
                        sequence : (index + 1)
                    }
                })
                return false;
            })

            let data = {
                document,
                status,
                profiles,
                props,
                docs : items
            }

            const response = await update({ id, data });

            // console.log('response', response)

            promptMessage(true, `${response?.message}`)

            navigate(getRoute(`documents/pickOrder/view/${id}`))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues : savedValues,
        validationSchema : validationSchemaCombine,
        enableReinitialize : true,
        onSubmit
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue, } = formik;

    // useEffect(() => {

    //     calculateSummaryValues();

    // }, [values])


    useEffect(() => {

        loadData(id)

    }, [])

    const onDragEnd = ({ destination, source }) => {
        // dropped outside the list
        if (!destination) return false;

        const newRows = reOrderArray(values.rows, source.index, destination.index);

        setFieldValue(`rows`, newRows)

        return true;
    };

    const handleAddItem = () => {

        const currentRows = values?.rows;

        currentRows.push(initialRowValues);
        setFieldValue('rows', currentRows)

    }

    const handleRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`itemsAtLeastHave1Row`))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    const RenderRow = ({ dragId, item, index, key }) => {

        const itemValues = item;
        let itemTouched = touched?.rows
        let itemErrors = errors?.rows
        // const itemTouched = touched?.rows

        if (itemTouched) {
            itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
        }

        if (itemErrors) {
            itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
        }

        return (
            <Draggable key={key} draggableId={dragId.toString()} index={index}>
                {
                    (provided, snapshot) => {

                        return (
                            <ListItem
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                sx={snapshot.isDragging ? { backgroundColor : grey[100], borderRadius : 2 } : {}}
                            >
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Grid container spacing={1}>

                                            <Grid item xs={12} sm={12} md={0.5} alignSelf={"center"}>
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={() => handleRemoveItem({ rows : values.rows, index, setFieldValue })}
                                                >
                                                    <CommonIcons name={icons.remove}/>
                                                </IconButton>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={3}>
                                                <SearchPickDocuments
                                                    routeType={routeType}
                                                    id={`rows.${index}.name`}
                                                    locationId={values?.locationId}
                                                    config={{
                                                        // filterDocumentType: searchDocumentConfig?.documentType,
                                                        // filterKeyword: searchDocumentConfig?.keyword
                                                        dialogDisplayText : `${t('SearchPickDocuments')} (${values?.locationName})`
                                                    }}
                                                    // show={searchDocumentConfig?.show}
                                                    handleOnCancel={() => {
                                                        // setOpenSearchDocuments(false)
                                                        // setSearchDocumentConfig(prev => ({...prev, show: false}))
                                                    }}
                                                    handleOnSearchChange={(event) => {
                                                        // setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                                                    }}
                                                    handleOnSelect={({ ids, items }) => {

                                                        // check the documents are selected in list
                                                        if (values?.rows.length > 0) {

                                                            let totalExists = 0

                                                            values?.rows.forEach(i => {
                                                                if (ids.includes(i.id) === true) {
                                                                    totalExists += 1
                                                                }
                                                            })

                                                            // console.log('totalExists, totalExists', totalExists)

                                                            if (totalExists > 0) {
                                                                promptMessage(false, t('thereAreDocumentsAlreadyExists', { exists : totalExists }))
                                                                return false
                                                            }
                                                        }


                                                        // console.log('ids', ids)
                                                        // console.log('items', items)

                                                        // insert the first one
                                                        setFieldValue(`rows.${index}.name`, items[0]?.doc_number)
                                                        setFieldValue(
                                                            `rows.${index}.description`,
                                                            items[0]?.delivery_profile_name
                                                        )
                                                        setFieldValue(`rows.${index}.id`, items[0]?.id)
                                                        setFieldValue(`rows.${index}.documentDocId`, 0)

                                                        // if more than 1
                                                        if (ids.length > 1) {

                                                            // console.log('ids.shift()', ids.shift())
                                                            // console.log('items.shift()', items.shift())

                                                            let newIds = ids.filter((i, ind) => ind !== 0)
                                                            let newItems = items.filter((i, ind) => ind !== 0)

                                                            // console.log('newIds', newIds, 'newItems', newItems)

                                                            // get the last index of the formik state rows
                                                            let currentRowsLength = values?.rows.length
                                                            let startIndex = currentRowsLength

                                                            // console.log('startIndex', startIndex)

                                                            newIds.forEach((i, ind) => {
                                                                setFieldValue(`rows.${startIndex}.name`, newItems[ind]?.doc_number)
                                                                setFieldValue(
                                                                    `rows.${startIndex}.description`,
                                                                    newItems[ind]?.delivery_profile_name
                                                                )
                                                                setFieldValue(`rows.${startIndex}.id`, newItems[ind]?.id)
                                                                setFieldValue(`rows.${startIndex}.documentDocId`, 0)
                                                                startIndex += 1
                                                            })
                                                        }

                                                        return true

                                                    }}
                                                    textProps={{
                                                        disabled : true,
                                                        value : itemValues?.name ? itemValues.name : "",
                                                        error : Boolean(itemErrors?.id),
                                                        helperText : itemErrors?.id
                                                    }}
                                                />

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={7.5}>
                                                <TextField
                                                    margin="dense"
                                                    size="small"
                                                    fullWidth
                                                    name={`rows.${index}.description`}
                                                    label={t("description")}
                                                    type="text"
                                                    variant="outlined"
                                                    value={itemValues?.description ? itemValues.description : ""}
                                                    onChange={handleChange}
                                                    error={Boolean(itemErrors?.description)}
                                                    helperText={itemErrors?.description}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={1} sx={{ mt : 2 }} display={"flex"} flexDirection={"row"} justifyContent={"center"}
                                                  alignItems={"flex-start"}>
                                                <CommonIcons name={icons.drag}/>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        )
                    }
                }
            </Draggable>
        )
    }

    const RenderRows = () => {

        const rows = values?.rows;

        return (
            <Box
            >
                <List>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable-list">
                            {provided => {
                                return (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        {
                                            rows && rows.length > 0
                                            && rows.map((item, index) => {

                                                return RenderRow({
                                                    key : index,
                                                    index,
                                                    dragId : index,
                                                    item
                                                })

                                            })
                                        }
                                        {provided.placeholder}
                                    </div>
                                )
                            }}
                        </Droppable>
                    </DragDropContext>
                </List>

                {
                    values?.isConfirmStatus === "0" &&
                    <>
                        <Grid item xs={12}>
                            <Divider sx={{ mt : 1, mb : 0 }}/>
                        </Grid>
                        {
                            RenderSummaryRow()
                        }
                    </>

                }

            </Box>
        )
    }

    const RenderSummaryRow = () => {
        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={4}>

                        <Button
                            variant="outlined"
                            sx={{ mt : 2 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.add}/>}
                            onClick={() => handleAddItem()}
                        >
                            {t('addItem')}
                        </Button>

                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>
                        <></>
                    </Grid>

                </Grid>

            </Grid>
        )
    }

    const RenderFormLocation = () => {

        if (!values) return <></>

        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`location`)}
                            subTitle={t(`relatedWarehouseLocationToProcess`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt : 1 }}>
                        <TextField
                            disabled
                            fullWidth
                            margin="dense"
                            size="small"
                            name={"locationId"}
                            label={t("locationFrom")}
                            type="text"
                            variant="outlined"
                            value={values.locationName}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                        />
                    </Grid>


                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt : 1 }}>
                        <Grid container spacing={1}>

                            <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name : "documentDate",
                                        label : t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                    sx={{
                                        width : '100%'
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"referenceNo"}
                                    label={t("referenceNo")}
                                    type="text"
                                    variant="outlined"
                                    value={values.referenceNo}
                                    onChange={handleChange}
                                    error={touched.referenceNo && Boolean(errors.referenceNo)}
                                    helperText={touched.referenceNo && errors.referenceNo}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        if (!values) return <></>

        return (
            <form onSubmit={handleSubmit}>

                {/* {
                        JSON.stringify(errors)
                    } */}

                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {
                            RenderFormLocation()
                        }

                    </Grid>

                </Grid>
                <StyledCard sx={{ mt : 1 }}>
                    <Grid container rowSpacing={0}>
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t(`documents`)}
                                subTitle={t(`detailInformationAboutTheDocumentsInvolved`)}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            {
                                RenderRows()
                            }

                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl : 2, pr : 2, mt : 3 }}>
                    <Grid item md={12} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                        {
                            values?.isConfirmStatus === "1" ?
                                (
                                    <Chip
                                        label={`${t('confirmedAt')} ${values?.isConfirmDate}`}
                                        color={"warning"}
                                        variant="contained"
                                    />
                                )
                                :
                                (
                                    <>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={actionConfirm}
                                                    onChange={() => { setActionConfirm(!actionConfirm) }}
                                                    name="actionConfirm"
                                                />
                                            }
                                            label={t("markAsConfirm")}
                                        />
                                        <LoadingButton
                                            type="submit"
                                            // fullWidth
                                            variant="contained"

                                            loading={isLoading}
                                        >
                                            {
                                                actionConfirm ? t(`yesIveConfirmed`) : t(`saveChanges`)
                                            }
                                        </LoadingButton>
                                    </>
                                )
                        }
                    </Grid>
                </Grid>

            </form>
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title : headTitles.updatePickOrder })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("updatePickOrder")}
                breadcrumbs={[
                    {
                        displayText : t("pickOrders"),
                        props : {
                            // underline: "hover",
                            href : getRoute('documents/pickOrders')
                        }
                    },
                    {
                        displayText : t("updatePickOrder"),
                        props : {
                            // disabled: true,
                            color : 'secondary.main',
                        }
                    },
                ]}
            />

            {/* {JSON.stringify(values?.rows)} */}

            {
                isPermissionAllow({ functionType : functionTypes.pageUpdate.id }) ?
                    RenderForm()
                    :
                    (
                        <CommonRestricted/>
                    )
            }

        </Box>
    )
}